export default function auth({ next, store }) {
    if (localStorage.getItem("authorization") === "true") {
        return next();
    }
    return next({
        name: "Login"
    });
}
